{
  "it": {
    "activity": {
      "attributes": {
        "end": "Fine",
        "now": "Ora",
        "title": "Cronologia"
      },
      "labels": {
        "no_activities": "Ancora nessuna voce nella cronologia",
        "no_activities_subtitle": "Quando qualcuno crea una nuova novità, decisione, domanda e così via, la troverà qui.",
        "not_opened_yet": "Non ancora visualizzato"
      },
      "projects": {
        "announcement": {
          "create": "ha creato una novità."
        },
        "building": {
          "create": "ha creato l'edificio <i>'{notifiable_name}'</i>."
        },
        "document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i>."
        },
        "lot": {
          "create": "ha creato il lotto <i>'{notifiable_name}'</i>."
        },
        "phase": {
          "create": "ha creato la fase <i>'{notifiable_name}'</i>."
        },
        "published": {
          "customer": "ha pubblicato la decisione <i>'{notifiable_name}'</i> per il cliente.",
          "partners": "ha pubblicato la decisione <i>'{notifiable_name}'</i> per il/i partner."
        },
        "question": {
          "create": "ha creato la domanda <i>'{notifiable_name}'</i> nelle FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "create": "ha creato la pertinenza <i>'{notifiable_name}'</i>.",
          "update": "ha assegnato la pertinenza <i>'{notifiable_name}'</i> a un'unità."
        },
        "survey_type": {
          "create": "ha creato un questionario di tipo <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "ha avviato la conversazione <i>'{notifiable_name}'</i>."
        },
        "unit": {
          "assign": "ha assegnato <i>'{notifiable_name}'</i> a un cliente.",
          "create": "ha creato l'unità <i>'{notifiable_name}'</i>.",
          "invisibled": "ha revocato l'accesso del cliente per <i>'{notifiable_name}'</i>.",
          "unassign": "ha rimosso l'assegnazione di <i>'{notifiable_name}'</i> dal cliente.",
          "visibled": "ha concesso l'accesso del cliente per <i>'{notifiable_name}'</i>."
        }
      },
      "units": {
        "announcement": {
          "create": "ha creato una novità."
        },
        "decision": {
          "create": "ha creato la decisione <i>'{notifiable_name}'</i>.",
          "not_interested": "non è interessato alla decisione <i>'{notifiable_name}'</i>.",
          "published": {
            "customer": "ha pubblicato la decisione <i>'{notifiable_name}'</i> per il cliente.",
            "partners": "ha pubblicato la decisione <i>'{notifiable_name}'</i> per il/i partner."
          },
          "relaunched": "ha reso di nuovo disponibile la decisione <i>'{notifiable_name}'</i>."
        },
        "decision_document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>."
        },
        "decision_proposal": {
          "approved": "ha approvato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>.",
          "create": {
            "customer": "ha condiviso la proposta <i>'{notifiable_name}'</i> con il cliente.",
            "employee": "ha creato la proposta <i>'{notifiable_name}'</i>.",
            "partnergroup": "ha condiviso la proposta <i>'{notifiable_name}'</i> con il partner <i>{target_name}</i>."
          },
          "unapproved": "ha annullato l'approvazione della proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>.",
          "updated": "ha aggiornato la proposta <i>'{notifiable_name}'</i> nella decisione <i>'{group_name}'</i>."
        },
        "document": {
          "create": "ha caricato il documento <i>'{notifiable_name}'</i>.",
          "destroy": "ha eliminato il documento <i>'{notifiable_name}'</i>"
        },
        "issue": {
          "approval": {
            "create": "ha richiesto l'approvazione del cliente.",
            "delete": "ha eliminato la richiesta di approvazione del cliente.",
            "rejected": "ha rifiutato questa segnalazione."
          },
          "approved": "ha approvato questa segnalazione",
          "create": "ha creato questa segnalazione",
          "status": {
            "update": "ha cambiato lo stato della segnalazione <i>'{notifiable_name}'</i> in <i>{target_name}</i>."
          }
        },
        "proposal": {
          "deleted": "ha rimosso la proposta <i>'{notifiable_name}'</i>."
        },
        "question": {
          "create": "ha creato la domanda <i>'{notifiable_name}'</i> nelle FAQ <i>'{group_name}'</i>."
        },
        "space": {
          "update": "ha assegnato la pertinenza <i>'{notifiable_name}'</i> a questa unità."
        },
        "survey": {
          "create": "ha creato il questionario <i>'{notifiable_name}'</i>.",
          "published": "ha pubblicato il questionario <i>'{notifiable_name}'</i>."
        },
        "ticket": {
          "create": "ha avviato la conversazione <i>'{notifiable_name}'</i>.",
          "message": {
            "move": "ha spostato un messaggio nella conversazione <i>'{notifiable_name}'</i>."
          }
        },
        "unit": {
          "assign": "ha assegnato <i>'{notifiable_name}'</i> a un cliente.",
          "invisibled": "ha revocato l'accesso del cliente per <i>'{notifiable_name}'</i>.",
          "unassign": "ha rimosso l'assegnazione di <i>'{notifiable_name}'</i> dal cliente.",
          "visibled": "ha concesso l'accesso del cliente per <i>'{notifiable_name}'</i>."
        }
      }
    }
  }
}
